import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { DECISION_ACTION_TYPES } from '../../enums/betTypes';
import Split from '../../assets/images/png-icons/split.png';
import Double from '../../assets/images/png-icons/double.png';

export const DECISION_ACTIONS_FOR_VIEW = [
  {
    betType: DECISION_ACTION_TYPES.Split,
    src: Split,
    className: 'split',
    name: 'SPLIT',
  },
  {
    betType: DECISION_ACTION_TYPES.Double,
    src: Double,
    className: 'double',
    name: 'DOUBLE',
  },
];

const DoubleOrSplitButtons = observer(
  ({ handleDecisionAction, possibleActions, liveDecisionActionCounts }) => {
    return (
      <div className={`${isMobile() ? 'm-' : ''}decision-buttons-column`}>
        <div className={`${isMobile() ? 'm-' : ''}decision-buttons-c-row`}>
          {DECISION_ACTIONS_FOR_VIEW.map(({ betType, name, className, src }) => {
            if (possibleActions.includes(betType)) {
              return (
                <div
                  onClick={() => handleDecisionAction(betType)}
                  key={betType}
                  className={`${isMobile() ? 'm-' : ''}decision-button ${className}`}
                >
                  <span className={`${isMobile() ? 'm-' : ''}decision-percent`}>
                    {liveDecisionActionCounts?.[betType] || null}
                  </span>
                  <img src={src} alt={name} className={`${isMobile() ? 'm-' : ''}decision-img`} />
                  <p className={`${isMobile() ? 'm-' : ''}decision-button-name`}>{name}</p>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
);
export default DoubleOrSplitButtons;
